import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=33593be8&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=33593be8&prod&scoped=true&lang=css"
import style1 from "./UserInfo.vue?vue&type=style&index=1&id=33593be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33593be8",
  null
  
)

export default component.exports